import { render, staticRenderFns } from "./MediaVideos.vue?vue&type=template&id=4aa0ba7c"
import script from "./MediaVideos.vue?vue&type=script&lang=js"
export * from "./MediaVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports